<fieldset ngModelGroup="detail">
    <!-- Title Field -->
    <form-field-input
        [(ngModel)]="domain.title"
        name="title"
        [label]="'Title' | translate"
        [placeholder]="'Title' | translate"
        type="text"
        [required]="true">
    </form-field-input>

    <!-- URL Field -->
    <form-field-input
        [(ngModel)]="domain.url"
        #domainUrlInput="ngModel"
        monValidateUrl
        name="url"
        [label]="'URL' | translate"
        [placeholder]="'URL' | translate"
        type="text"
        [required]="true"
        [httpPrefix]="'true'">
    </form-field-input>
    <form-field-errors [input]="domainUrlInput" />

    <div class="row outer-t-medium"></div>
    <hr class="row"/>

    <form-domain-cms [domain]="domain" (validityChange)="cmsValidityChange.emit($event)"/>

    <hr class="row" *ngIf="!noLanguageSelector"/>

    <!-- Language Selection -->
    <div *ngIf="languages.length > 0 && !noLanguageSelector">
        <form-field-select
            [(ngModel)]="domain.language"
            name="language"
            *ngIf="!loadingLanguages"
            [label]="'language' | translate"
            [defaultOption]="'language' | translate"
            [options]="languages"
            [returnValue]="'code'"
            [helpTxt]="'Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.' | translate">
        </form-field-select>
    </div>
</fieldset>
